<template>
<div  class="flex flex-col">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 3 of 6
  </p> -->

  <label
    for="location"
    class="flex flex-col justify-end text-xl text-gray-700 font-medium sm:text-2xl"
  >
    <!-- Where would you be happy for your tuition to take place? -->
    Online or in-person?
    <!-- How would you like it? -->
  </label>
  <p class="mt-2 text-sm text-gray-500">
    You may choose both.
  </p>

  <div class="mt-8 grid grid-cols-2 gap-2 w-full max-w-md">
    <button
      v-for="(item, idx) of locations"
      class="flex flex-col justify-center items-center h-24 bg-gray-100 rounded-md border-2 border-gray-100 relative group hover:bg-blue-50 hover:border-blue-50"
      :class="{ 'border-blue-500 bg-blue-50 hover:bg-blue-50 hover:border-blue-500': selectedLocations.find(x => x === item.value) }"
      @click="toggleLocation(item.value)"
    >
      <Heroicon
        v-if="item.icon"
        :icon="item.icon"
        class="w-8 h-8"
        :class="item.color"
      />
      <img
        v-else
        :src="item.image"
        class="h-8"
      />
      <span class="mt-2.5 text-sm font-semibold text-gray-800 sm:hidden">
        {{ item.label }}
      </span>
      <span class="mt-2.5 hidden text-sm font-semibold text-gray-800 sm:block">
        {{ item.longLabel ? item.longLabel : item.label }}
      </span>
      <Heroicon 
        :icon="selectedLocations.find(x => x === item.value) ? 'circle-check' : 'circle'" 
        class="absolute top-2 right-2 w-5 h-5"
        :class="[selectedLocations.find(x => x === item.value) ? 'text-blue-600' : 'text-gray-300 filter saturate-50 group-hover:text-blue-200']"
      />
    </button>
  </div>

  <input
    v-show="selectedLocations.find(x => x === 'INPERSON')"
    v-model.trim="postcode"
    autocomplete="postal-code"
    placeholder="Your postcode"
    maxlength="10"
    class="postcode mt-3 p-3 max-w-md rounded-md text-base uppercase placeholder-gray-500 border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
  />

  <button type="button" @click="nextStep" class="mt-6 self-start inline-flex items-center gap-x-2.5 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
    Next
    <svg class="-mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
      <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" fill="currentColor" />
    </svg>
  </button>

</div>
</template>

<script>

import Heroicon from '@/prototype/Heroicon.vue'

export default {
  components: {
    Heroicon,
  },
  props: {
    enquiry: Object,
  },
  data() {
    return {
      locations: [
        // { label: 'Either', longLabel: 'No preference', value: 'NOPREFERENCE', icon: 'location-question', color: 'text-green-600' },  
        { label: 'Online', value: 'ONLINE', icon: 'wifi', color: 'text-blue-500' },
        { label: 'In-person', value: 'INPERSON', icon: 'user-group-simple', color: 'text-pink-600' },
      ],
      selectedLocations: ['ONLINE', 'INPERSON'],
      postcode: null,
    }
  },
  methods: {
    toggleLocation(location) {
      if (this.selectedLocations.find(x => x === location)) {
        // Remove
        this.selectedLocations.splice(this.selectedLocations.findIndex(x => x === location), 1)
      }
      else {
        // Add
        this.selectedLocations.push(location)
      }
    },
    nextStep() {
      this.$emit('updateEnquiry', { 
        locations: this.selectedLocations,
        postcode: this.postcode,
      })

      this.$router.push({
        name: 'FindATutor-Rate'
      })
    }
  },
  mounted() {
    if (this.enquiry.locations) this.selectedLocations = this.enquiry.locations
    if (this.enquiry.postcode) this.postcode = this.enquiry.postcode
  }
}
</script>
<style lang="scss" scoped>

.postcode::placeholder {
  text-transform: none;
}

</style>